module.exports = __webpack_public_path__ + "img/south-map.e73e382a.png";